module.exports = __webpack_public_path__ + "media/images/training-close-evaluation-modal-2886abb4d0467fdd6343329a642450cc.svg";